<template>
  <div class="used-lower-default-footer">
    <div class="thank-you-message">ご利用ありがとうございました</div>
    <div class="checkout-date">
      {{ $t("MyTicketTicketing.checkoutDate") }}: {{ displayStampedAt }}
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import moment from "@/services/moment";

export default {
  name: "SFaceUsedLowerDefaultFooter",
  props: {
    stampedAt: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const displayStampedAt = computed(() =>
      moment(new Date(props.stampedAt)).format("YYYY.MM.DD HH:mm")
    );

    return { displayStampedAt };
  },
};
</script>

<style lang="scss" scoped>
.used-lower-default-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #000000;
  padding: 2vh 0 3vh;
  gap: 1vh;
}

.thank-you-message {
  font-size: 14px;
  color: #ffffff;
}

.checkout-date {
  font-size: 14px;
  color: #ffffff;
}
</style>
